var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3206 9C10.3108 8.6582 10.1838 8.36523 9.92017 8.10156L2.32251 0.669922C2.0979 0.455078 1.83423 0.337891 1.51196 0.337891C0.857666 0.337891 0.349854 0.845703 0.349854 1.5C0.349854 1.8125 0.476807 2.10547 0.701416 2.33008L7.53735 9L0.701416 15.6699C0.476807 15.8945 0.349854 16.1777 0.349854 16.5C0.349854 17.1543 0.857666 17.6621 1.51196 17.6621C1.82446 17.6621 2.0979 17.5449 2.32251 17.3301L9.92017 9.88867C10.1936 9.63477 10.3206 9.3418 10.3206 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronForward);
export default __webpack_public_path__ + "static/media/chevron-forward.28f98ff755816c46e3b1faaddbc503d4.svg";
export { ForwardRef as ReactComponent };